/**
 * Formik keeps `touched` as arrays parallel to list values (roles, zones). Removing
 * or appending an item doesn't update them, so a new item at a reused index would
 * inherit the removed item's touched flags and show its errors (PROLINE-2514).
 */

/** `touched` with the entry at `index` removed from `touched[listKey]`, shifting later entries. */
export const removeTouchedListItem = (touched, listKey, index) => {
  const list = touched?.[listKey];
  if (!Array.isArray(list)) return touched;
  return { ...touched, [listKey]: list.filter((_item, i) => i !== index) };
};

/** `touched` with no entry at `index` of `touched[listKey]` (for a freshly appended item). */
export const clearTouchedListItem = (touched, listKey, index) => {
  const list = touched?.[listKey];
  if (!Array.isArray(list) || list[index] === undefined) return touched;
  const nextList = [...list];
  nextList[index] = undefined;
  return { ...touched, [listKey]: nextList };
};
